import { render, staticRenderFns } from "./PortfolioFunded.vue?vue&type=template&id=3ac462c4&"
import script from "./PortfolioFunded.vue?vue&type=script&lang=js&"
export * from "./PortfolioFunded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports